"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setColumnsProperty = void 0;
const model_1 = require("../../model");
const selectors_1 = require("../../exports/store/selectors");
const i18n_1 = require("../../exports/i18n");
const types_1 = require("../../types");
const command_manager_1 = require("../../command_manager");
exports.setColumnsProperty = {
    undoable: true,
    execute: (context, options) => {
        const { model: state } = context;
        const { fieldId, viewId, data } = options;
        const { width, statType } = data;
        const datasheetId = (0, selectors_1.getActiveDatasheetId)(state);
        const datasheet = (0, selectors_1.getDatasheet)(state, datasheetId);
        const fieldMap = (0, selectors_1.getFieldMap)(state, datasheetId);
        if (!state || !datasheet) {
            return null;
        }
        // Determine whether the currently operating view is the active view
        if (datasheet.activeView !== viewId) {
            throw new Error((0, i18n_1.t)(i18n_1.Strings.error_modify_column_failed_wrong_target_view));
        }
        if (!fieldMap[fieldId]) {
            throw new Error((0, i18n_1.t)(i18n_1.Strings.error_modify_column_failed_column_not_exist));
        }
        const actions = [];
        if (width) {
            const changeColumnsWidthAction = model_1.DatasheetActions.setColumnWidth2Action(datasheet.snapshot, { viewId, fieldId, width });
            changeColumnsWidthAction && actions.push(changeColumnsWidthAction);
        }
        if (statType != null) {
            const changeFieldStatAction = model_1.DatasheetActions.setColumnStatType2Action(datasheet.snapshot, { viewId, fieldId, statType });
            changeFieldStatAction && actions.push(changeFieldStatAction);
        }
        if (actions.length === 0) {
            return null;
        }
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: datasheetId,
            resourceType: types_1.ResourceType.Datasheet,
            actions,
        };
    },
};
/*

declare module '../../command_manager/command_manager' {
  interface CollaCommandManager {
    execute(options: ISetRecordsOptions & { cmd: 'SetRecords' });
  }
}

*/
//# sourceMappingURL=set_columns_property.js.map